var _circle, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    fill: "#FFFFFF",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.7,
    cy: 14.3,
    r: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m79.9 34.8c-0.5-1.6-2.1-2.6-3.8-2.1-5.5 1.5-20.5 5.6-24.8 6l-7.3 0.6c-4 0.3-8.5-3.2-9.6-4.4-0.7-1-3.7-7.1-6.3-12.6l5-4c1.3 1.1 3.1 1.8 5 1.8 2.3 0 4.7-0.9 6.7-2.5s3.4-3.7 3.9-6c0.5-2.4 0.1-4.7-1.3-6.4-2.8-3.5-8.5-3.6-12.7-0.2-2 1.6-3.4 3.7-3.9 6-0.4 1.9-0.2 3.8 0.6 5.3l-4.8 3.8c-1.2-0.9-2.9-0.9-4.1 0.3-0.9 0.9-1 2.2-0.5 3.3l-1.8 1.4c-0.5 0.4-0.6 1.2-0.2 1.8 0.3 0.3 0.6 0.5 1 0.5 0.3 0 0.6-0.1 0.8-0.3l1.3-1c2.6 5.5 5.5 11.4 6.6 12.6 1.4 1.6 5.9 5.4 11.3 6.4 0.7 3.1 2.4 11.1 2.3 17.2-0.9 3.8-2.3 8.6-3.1 10.1-1.6 0.8-7.1 2.5-11.7 3.7-1.8 0.5-3.1 2.2-2.8 4 0.3 2.1 2.4 3.4 4.4 2.9 8.2-2.2 13.2-4 14.7-5.2 0.6-0.5 2.3-1.9 4.6-11.1 0.8 4 1.8 9.2 1.8 11-0.1 1.7-3.2 8.9-6 14.5-0.8 1.6-0.5 3.5 0.9 4.6 0.7 0.5 1.4 0.7 2.2 0.7 1.3 0 2.5-0.7 3.2-1.9 2.6-5.2 7-14.4 6.9-18.1-0.1-2.9-1.6-10.2-2.2-13.4 1.6-10 0.1-17.1-0.8-19.9 7.6-1.5 20.4-5.1 22.1-5.6 2-0.5 2.9-2.2 2.4-3.8zm-46.5-23.3c0.4-1.7 1.5-3.4 3-4.6 1.7-1.2 3.5-1.9 5.2-1.9 1.6 0 3.1 0.6 4 1.8 0.9 1.1 1.2 2.6 0.8 4.3s-1.5 3.4-3 4.6c-1.6 1.2-3.4 1.9-5.2 1.9-1.7 0-3.1-0.6-4-1.7s-1.1-2.7-0.8-4.4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.9969 -.078324 .078324 .9969 -2.172 3.7707)",
    cx: 47,
    cy: 29.6,
    rx: 7.2,
    ry: 7.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenn);
export default __webpack_public_path__ + "static/media/TENN.07f0bf39fb6077b420277f374a6285d7.svg";
export { ForwardRef as ReactComponent };